"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for unauthorised responses for operations
 */
class UnauthorisedError extends client_library_1.ExtendableError {
    constructor() {
        super(`User unauthorised to perform operation`);
    }
}
exports.default = UnauthorisedError;
